// src/components/Panels/Charts/DonutChart/index.js
import React from 'react';
import { DonutChart } from "@carbon/charts-react";
import ChartPanelWrapper from "../ChartPanelWrapper";
import { transformToGroupValue, buildChartTitle, buildColorScale } from "../chartHelpers";
import "./_index.scss";

const Index = ({chart}) => {
    const centerLabel = chart.title?.toUpperCase()
        || chart.name?.toUpperCase()
        || chart.y_label?.toUpperCase()
        || chart.y_columns?.map(a => a.column_name.toUpperCase()).join(' / ')
        || '';

    return (
        <ChartPanelWrapper chart={chart}>
            {(panelData, renderChart) => {
                const data = transformToGroupValue(panelData, chart);
                const colorScale = buildColorScale(data);
                const options = {
                    title: buildChartTitle(chart),
                    resizable: true,
                    height: "400px",
                    donut: {
                        alignment: "center",
                        center: { label: centerLabel }
                    },
                    color: { scale: colorScale }
                };
                    return renderChart(data, (
                    <div className="mm-donut-chart">
                        <DonutChart options={options} data={data} />
                    </div>
                    ));
            }}
        </ChartPanelWrapper>
    );
}

export default React.memo(Index)
